import { useMemo } from 'react';
import { getErrorCode, shouldReportError } from '../../../../critical/utils';
import { BI_ERRORS, errorLogger } from '../../../../services/loggers/errorLogger';
import { MediaManagerSDKUploadingFile } from '../../../media-manager-sdk';
import { IUseTrackUpload } from './useTrackUpload.types';

export const useTrackUpload = (): IUseTrackUpload =>
  useMemo(
    () => ({
      trackUpload: (mappedFiles: MediaManagerSDKUploadingFile[]) => {
        mappedFiles.forEach((file) => {
          file.deferred.promise.catch((reason) => {
            if (shouldReportError(reason)) {
              errorLogger.log(BI_ERRORS.mediaManagerSDK.uploadItem, { reason, p1: String(getErrorCode(reason)) });
            }
          });
        });
      },
    }),
    [],
  );
